/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */

import DetailModal from './DetailModal';
import Footer from './Footer';
import LogViewer from './LogViewer';
import ProFormTextSearch from './ProFormTextSearch';
import ResizableTitle from './ResizableTitle';
import { Question, SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';
import SelectAdvertModal from './SelectAdvertModal';
import SelectChannelModal from './SelectChannelModal';
import VersionCheck from './VersionCheck';

export {
  AvatarDropdown,
  AvatarName,
  DetailModal,
  Footer,
  LogViewer,
  ProFormTextSearch,
  Question,
  ResizableTitle,
  SelectAdvertModal,
  SelectChannelModal,
  SelectLang,
  VersionCheck,
};
